import { NavigationTabs, type NavigationTabItem } from '@exam-management/components';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'qconfig',
    label: 'QConfig',
    path: '/exam-courses/:courseId/qconfigs',
    requiredPermission: [APP_PERMISSIONS.EXAM.QCONFIG.VIEW],
  },
  {
    value: 'qconfig-generator',
    label: 'QConfig Generator',
    path: '/exam-courses/:courseId/qconfig-generators',
    requiredPermission: [APP_PERMISSIONS.EXAM.QCONFIG.VIEW],
  },
  {
    value: 'qset',
    label: 'QSet',
    path: '/exam-courses/:courseId/qsets',
    requiredPermission: [APP_PERMISSIONS.EXAM.QSET.VIEW],
  },
];

export default function ExaminationCourseNavigationTabs() {
  const { permissions } = usePermission();

  const tabList = useMemo(
    () =>
      TAB_ITEMS.filter(
        (tab) =>
          !tab.requiredPermission ||
          tab.requiredPermission.every((permission) => permissions.includes(permission)),
      ),
    [permissions],
  );
  return <NavigationTabs items={tabList} />;
}
